import React, { useMemo, useState } from "react";
import "./PhotoComponent.scss";
import ButtonComponent from "../ButtonComponent/ButtonComponent";

const defaultSections = [
  {
    key: "pre",
    title: "Pre Shoot",
    photos: [
      { src: "https://images.unsplash.com/photo-1522673607200-164d1b6ce486?q=80&w=1200&auto=format&fit=crop", alt: "Pre shoot 1" },
      { src: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?q=80&w=1200&auto=format&fit=crop", alt: "Pre shoot 2" },
      { src: "https://images.unsplash.com/photo-1522335789203-9d83f0e7930b?q=80&w=1200&auto=format&fit=crop", alt: "Pre shoot 3" },
      { src: "https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=1200&auto=format&fit=crop", alt: "Pre shoot 4" },
      { src: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=1200&auto=format&fit=crop", alt: "Pre shoot 5" },
      { src: "https://images.unsplash.com/photo-1521215990319-4f7f06c2f1fb?q=80&w=1200&auto=format&fit=crop", alt: "Pre shoot 6" },
      { src: "https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=1200&auto=format&fit=crop", alt: "Pre shoot 7" },
      { src: "https://images.unsplash.com/photo-1460364157752-926555421a7e?q=80&w=1200&auto=format&fit=crop", alt: "Pre shoot 8" },
      { src: "https://images.unsplash.com/photo-1522673607200-163d1b6ce486?q=80&w=1200&auto=format&fit=crop", alt: "Pre shoot 9" },
      { src: "https://images.unsplash.com/photo-1522335789203-9d83f0e7930b?q=80&w=1200&auto=format&fit=crop", alt: "Pre shoot 10" },
      { src: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1200&auto=format&fit=crop", alt: "Pre shoot 11" },
    ],
  },
  {
    key: "proposal",
    title: "Proposal",
    photos: [
      { src: "https://images.unsplash.com/photo-1519744346366-3f2f2b1b2b88?q=80&w=1200&auto=format&fit=crop", alt: "Proposal 1" },
      { src: "https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=1200&auto=format&fit=crop", alt: "Proposal 2" },
      { src: "https://images.unsplash.com/photo-1500622944204-b135684e99fd?q=80&w=1200&auto=format&fit=crop", alt: "Proposal 3" },
    ],
  },
  {
    key: "engagement",
    title: "Engagement",
    photos: [
      { src: "https://images.unsplash.com/photo-1460364157752-926555421a7e?q=80&w=1200&auto=format&fit=crop", alt: "Engagement 1" },
      { src: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=1200&auto=format&fit=crop", alt: "Engagement 2" },
      { src: "https://images.unsplash.com/photo-1500622944204-b135684e99fd?q=80&w=1200&auto=format&fit=crop", alt: "Engagement 3" },
    ],
  },
];

const VISIBLE_COUNT = 10;

const PhotoComponent = ({
  title = "Moments of Beauty",
  sections = defaultSections,
  moreLink = "#gallery",            // set your full gallery link
  moreLabel = "Show more",
}) => {
  const sectionFilters = useMemo(() => sections.map(s => ({ key: s.key, title: s.title })), [sections]);

  // default to first section
  const [active, setActive] = useState(sectionFilters[0]?.key || "");
  const [lightbox, setLightbox] = useState(null); // {src, alt}

  const currentSection = useMemo(
    () => sections.find(s => s.key === active) || sections[0] || { photos: [] },
    [active, sections]
  );

  const photos = useMemo(
    () => (currentSection.photos || []).slice(0, VISIBLE_COUNT),
    [currentSection]
  );

  return (
    <section className="photos" aria-label="Photo Gallery">
      <div className="photos__header">
        <h2 className="photos__title">{title}</h2>

        <div className="photos__filters" role="tablist" aria-label="Photo categories">
          {sectionFilters.map(f => (
            <button
              key={f.key}
              role="tab"
              aria-selected={active === f.key}
              className={`photos__chip ${active === f.key ? "is-active" : ""}`}
              onClick={() => setActive(f.key)}
            >
              {f.title}
            </button>
          ))}
        </div>
      </div>

      {/* 5 per row × 2 rows (10 total) */}
      <div className="photos__grid">
        {photos.map((p, i) => (
          <figure key={`${p.src}-${i}`} className="photo">
            <button className="photo__inner" onClick={() => setLightbox({ src: p.src, alt: p.alt })}>
              <img src={p.src} alt={p.alt} loading="lazy" decoding="async" />
            </button>
          </figure>
        ))}
      </div>

      <div className="photos__actions">
        <ButtonComponent size = "sm" as="a" href={moreLink} target="_blank" rel="noopener noreferrer">
          {moreLabel}
        </ButtonComponent>
      </div>

      {lightbox && (
        <div className="photos__lightbox" onClick={() => setLightbox(null)} role="dialog" aria-modal="true">
          <div className="lightbox__frame">
            <img src={lightbox.src} alt={lightbox.alt || "Photo"} />
            <button className="lightbox__close" aria-label="Close" onClick={() => setLightbox(null)}>✕</button>
          </div>
        </div>
      )}
    </section>
  );
};

export default PhotoComponent;
